angular
    .module('tradersyard')
    .factory('news-read-filter', [
        '$flex',
        function ($flex) {
            var tab,
                hash,
                filter = {
                    init: function () {
                        filter.set(filter.get());
                    },
                    is: function (name) {
                        return tab === name;
                    },
                    get: function () {
                        hash = $flex.$hash.get();

                        return ['timeline', 'post', 'performance', 'portfolio', 'history'].indexOf(hash) !== -1
                            ? hash
                            : 'timeline';
                    },
                    set: function (name) {
                        tab = name;

                        if (filter.on.change) filter.on.change();

                        $flex.$touch.make(name);
                        $flex.$hash.set(name);
                    },
                    tab: function () {
                        return tab;
                    },
                    on: {
                        change: undefined,
                    },
                };

            return filter;
        },
    ])
    .controller('news-filter-ctrl', [
        '$scope',
        '$rootScope',
        'graph-group-factory',
        'graph-term-storage',
        '$socket',
        'updatesService',
        function ($scope, $root, $group, $term, $socket, $updates) {
            $updates.cleanUpdates();

            var $walk = function ($array, $call) {
                for (var i = 0; i < $array.length; i++) {
                    $call($array[i]);

                    if ($array[i].categories.length > 0) $walk($array[i].categories, $call);
                }
            };

            $scope.params = {
                page: 0,
                filter: 'my',
            };

            $scope.ui = {
                mode: 'my',
            };

            $scope.categories = [];
            $scope.groups = [];

            $scope.attachment = {
                document: 'Document',
                spreadsheet: 'Spreadsheet',
                presentation: 'Presentation',
                archive: 'Archive',
                agenatrader: 'AgenaTrader',
                video: 'Video',
                photo: 'Photo',
            };

            $scope.filter = {
                categories: [],
                groups: [],
                attachment: {
                    document: true,
                    spreadsheet: true,
                    presentation: true,
                    archive: true,
                    agenatrader: true,
                    video: true,
                    photo: true,
                },
                select: {
                    group: {
                        all: false,
                    },
                    attach: {
                        all: false,
                    },
                },
            };

            $scope.query = {
                group: [],
                attach: [],
                compile: function () {
                    $scope.query.group = [];
                    $scope.query.attach = [];

                    for (var ix in $scope.groups) {
                        var group = $scope.groups[ix];

                        if ($scope.filter.groups[group.id] === true && $scope.fn.group.filter(group))
                            $scope.query.group.push(group.id);
                    }

                    for (var type in $scope.filter.attachment) {
                        if ($scope.filter.attachment[type] === true) $scope.query.attach.push(type);
                    }
                },
            };

            $scope.$http = {
                load: function () {
                    $term.load(function (groups, categories) {
                        $scope.groups = groups;
                        $scope.categories = categories;

                        for (var i = 0; i < $scope.groups.length; i++) {
                            $scope.filter.groups[$scope.groups[i].id] = false;
                        }
                    });
                },
            };

            $scope.filtrate = function () {
                $root.$broadcast('news-filter-update', {
                    groups: $scope.query.group.join(','),
                    attaches: encodeURIComponent($scope.query.attach.join(',')),
                });
            };

            $scope.fn = {
                category: {
                    change: function ($node, $selected, $tree) {
                        $scope.filter.categories = [];

                        $walk($tree, function ($node) {
                            if ($node.selected === true) $scope.filter.categories.push($node.id);
                        });

                        $scope.query.compile();
                    },
                },
                group: {
                    all: function () {
                        for (var id in $scope.filter.groups) $scope.filter.groups[id] = $scope.filter.select.group.all;

                        $scope.query.compile();
                    },
                    change: function ($id) {
                        $scope.filter.select.group.all = false;

                        for (var ix in $scope.groups) {
                            var group = $scope.groups[ix];

                            if ($scope.filter.groups[group.id] === true && $scope.fn.group.filter(group)) {
                                $scope.filter.select.group.all = true;
                                break;
                            }
                        }

                        $scope.query.compile();
                    },
                    filter: function ($group) {
                        var $collection = $scope.filter.categories;

                        return $collection.length <= 0 || $collection.indexOf($group.category.id) !== -1;
                    },
                },
                attach: {
                    all: function () {
                        for (var type in $scope.filter.attachment)
                            $scope.filter.attachment[type] = $scope.filter.select.attach.all;

                        $scope.query.compile();
                    },
                    change: function (key) {
                        $scope.filter.select.attach.all = false;

                        for (var type in $scope.filter.attachment) {
                            if ($scope.filter.attachment[type] === true) {
                                $scope.filter.select.attach.all = true;
                                break;
                            }
                        }

                        $scope.query.compile();
                    },
                },
                filter: {
                    all: function () {
                        $scope.ui.mode = 'all';

                        $scope.fn.filter.cast({
                            scope: 'all',
                            groups: $scope.query.group.join(','),
                            attaches: encodeURIComponent($scope.query.attach.join(',')),
                        });
                    },
                    my: function () {
                        $scope.ui.mode = 'my';

                        $scope.fn.filter.cast({
                            scope: 'my',
                        });
                    },
                    man: function () {
                        $scope.ui.mode = 'man';
                    },
                    cast: function (options) {
                        $root.$broadcast('news-filter-update', options);
                    },
                },
            };

            $root.$on('homeButtonClick', function (bool) {
                if ($scope.ui.mode === 'all') {
                    $scope.fn.filter.my();
                }
            });

            $scope.$http.load();
            $scope.fn.group.all();
            $scope.fn.attach.all();
        },
    ])
    .controller('news-query-ctrl', [
        '$q',
        '$rootScope',
        '$scope',
        'graph-news-factory',
        'graph-post-factory',
        '$flex',
        'news-read-filter',
        '$timeout',
        '$flex.scroll',
        'graph-like-factory',
        '$flex.array',
        '$socket',
        'updatesService',
        'AuthService',
        'AdsService',
        function (
            $q,
            $rootScope,
            $scope,
            $factory,
            postFactory,
            $flex,
            $filter,
            $timeout,
            $scroll,
            $like,
            $array,
            $socket,
            $updates,
            Auth,
            AdsService
        ) {
            // region: Boosted Posts

            /**
             * Keeps posts loaded from the API. WITHOUT boosted posts.
             * Boosted posts should be merged with this list.
             *
             * @type {object[]}
             */
            const LOADED_POSTS = [];

            function getRankForRange(range) {
                const rangeRank = {
                    1: AdsService.uniqueRandomGenerator(1, 5),
                    2: AdsService.uniqueRandomGenerator(6, 15),
                    3: AdsService.uniqueRandomGenerator(16, 30),
                };

                const rank = rangeRank[range]();
                console.log('[BOOSTED POSTS] Assigned rank %d', rank);
                return rank;
            }

            const boostedPostsPromise = AdsService.getBoostedPostsWithAssignedRank(getRankForRange).catch((err) => {
                console.warn('No boosted post fetched');
                return []; // return empty array in case of error, so further processing will work fine
            });

            /**
             * You should call this every time a new list of posts is loaded.
             *
             * @param newPosts
             * @return {angular.IPromise<Object[]>}
             */
            function concatPostsWithBoosted(newPosts) {
                // this appends the new items in place
                LOADED_POSTS.push(...newPosts);
                return boostedPostsPromise.then((boostedPosts) => {
                    return AdsService.combineBoostedPostsInto(boostedPosts, LOADED_POSTS);
                });
            }

            // endregion: Boosted Posts

            $scope.filter = $filter;

            // Initialize nodes with empty array - we will be using concat
            $scope.nodes = [];

            $scope.params = {
                scope: 'public-timeline',
                page: 0,
            };

            $scope.$on('news-filter-update', function (e, options) {
                $scope.params.page = 0;
                $scope.params = angular.extend($scope.params, options);
                $scope.nodes = [];
                $scope.query();
                $flex.$scroll.renew('timeline');
            });

            $scope.query = function (next) {
                // Each time we call this function we increase page counter.
                // This function is called when scrolling the view.
                ++$scope.params.page;

                /**
                 * This is where News Feed Posts are loaded and this is where we want to show Boosted posts.
                 */
                $factory
                    .entry('user', 'me')
                    .query({ params: $scope.params })
                    .then(function (response) {
                        if (response.data.state !== 0 || response.data.data.length < 1) {
                            return; // early return on error or empty result
                        }

                        let postNodes = response.data.data;

                        concatPostsWithBoosted(postNodes).then((withBoosted) => ($scope.nodes = withBoosted));

                        // Start listening for events on those new posts
                        const postIds = postNodes.map((post) => post.id);
                        $socket.emit('join:post', postIds);

                        if (next) next();
                    });
            };

            $socket.on('comment:create', function (data) {
                if (data.place.name === 'post') {
                    $scope.nodes.forEach(function (node) {
                        if (parseInt(node.id) === parseInt(data.place.id)) {
                            ++node.comments;
                            if (!$scope.$$phase) {
                                $scope.$digest();
                            }
                        }
                    });
                }
            });

            $socket.on('comment:delete', function (data) {
                if (data.place.name === 'post') {
                    $scope.nodes.forEach(function (node) {
                        if (parseInt(node.id) === parseInt(data.place.id)) {
                            --node.comments;
                            if (!$scope.$$phase) {
                                $scope.$digest();
                            }
                        }
                    });
                }
            });

            function userCanAction(node) {
                if (!Auth.isUserAuthenticated()) {
                    return false;
                }

                if (node.owner.id === $rootScope.me.id) {
                    return true;
                }

                return false;
            }

            $scope.userCanEditComment = userCanAction;
            $scope.userCanDeleteMessage = userCanAction;

            $scope.like = function (item) {
                $like
                    .entry('post', item.id)
                    .like()
                    .then(function (response) {
                        if (response.data.state === 0) {
                            item.im_like = true;
                            ++item.likes;
                        }
                    });
            };

            $scope.unlike = function (item) {
                $like
                    .entry('post', item.id)
                    .unlike()
                    .then(function (response) {
                        if (response.data.state === 0) {
                            item.im_like = false;
                            --item.likes;
                        }
                    });
            };

            $scope.filter.on.change = function () {
                $scroll.switch($scope.filter.tab());
            };

            $scope.$on('touch:timeline', function () {
                $scope.query();
            });

            $scope.$on('touch:performance', function () {
                $timeout(function () {
                    $scope.$broadcast('analytic-statistics-init');
                }, 10);
            });

            $scope.$on('touch:portfolio', function () {
                $timeout(function () {
                    $scope.$broadcast('analytic-portfolio-init');
                }, 10);
            });

            $scope.$on('touch:history', function () {
                $timeout(function () {
                    $scope.$broadcast('analytic-history-init');
                }, 10);
            });

            $socket.on('post:create', function (message) {
                if (
                    $scope.nodes
                        .map(function (item) {
                            return Number(item.id);
                        })
                        .indexOf(Number(message.node.id)) === -1
                ) {
                    $socket.emit('join:post', [message.node.id]);

                    if (message.node.owner.id === $rootScope.me.id) {
                        $scope.nodes.unshift(message.node);

                        if (!$scope.$$phase) $scope.$digest();
                    } else {
                        $updates.appendUpdate(message.node);
                    }
                }
            });

            $scope.showUpdates = function () {
                return $updates.updatesQueue.length > 0;
            };

            $scope.cleanUpdates = function () {
                var updatesQueue = $updates.cleanUpdates();
                var defaultNodes = $scope.nodes;
                $scope.nodes = updatesQueue.concat(defaultNodes);
            };

            angular.extend($scope, $flex.data);

            $scope.$on('$historyBack', $filter.init);
        },
    ]);
